import Component from '../component/component';
import Range from '../forms/range/range';

import './filter.scss';

export default class Filter extends Component {
    static initSelector: string = '.filter';

    dropdown: JQuery;
    trigger: JQuery;
    onlyFreeToggle: JQuery;
    hasBalconyToggle: JQuery;
    isCompletedToggle: JQuery;
    roomsRadio: JQuery;
    houseNumberRadio: JQuery;
    typeRadio: JQuery;
    rangeFilters: JQuery;
    clearFilters: JQuery;
    rows: JQuery;
    tableBody: JQuery;

    private defaultSizeRange: string[];
    private defaultPriceRange: string[];

    constructor(target: HTMLElement) {
        super(target);

        this.dropdown = this.element.find('.filter__dropdown');
        this.trigger = this.element.find('.filter__dropdown-trigger');
        this.onlyFreeToggle = this.element.find('[name="only_available"]');
        this.hasBalconyToggle = this.element.find('[name="has_balcony"]');
        this.isCompletedToggle = this.element.find('[name="is_completed"]');
        this.houseNumberRadio = this.element.find('[name="houseNumber"]');
        this.roomsRadio = this.element.find('[name="rooms"]');
        this.typeRadio = this.element.find('[name="apartmentType"]');
        this.rangeFilters = this.element.find('.js-range');
        this.clearFilters = this.element.find('button.filter__reset');

        const scope: JQuery = this.element.closest('.js-pricelist, .pricelist');
        const tableScope: JQuery = (scope.length ? scope : $(document.documentElement));

        this.rows = tableScope.find('.pricelist__table tbody tr.table__row');
        this.tableBody = tableScope.find('.pricelist__table .table__body');

        this.init();
    }

    init(): void {
        this.clearFilters.hide();
        this.trigger.on('click', this.toggle.bind(this));
        this.clearFilters.on('click', this.clearAllFilters.bind(this));

        if (this.onlyFreeToggle.length) {
            this.onlyFreeToggle.prop('checked', true);
        }

        this.onlyFreeToggle.on('change', this.updateFilters.bind(this));
        this.hasBalconyToggle.on('change', this.updateFilters.bind(this));
        this.isCompletedToggle.on('change', this.updateFilters.bind(this));
        this.houseNumberRadio.on('change', this.updateFilters.bind(this));
        this.roomsRadio.on('change', this.updateFilters.bind(this));
        this.typeRadio.on('change', this.updateFilters.bind(this));
        this.defaultSizeRange = `${this.element.find('[name="size"]').val()}`.split(',');
        this.defaultPriceRange = `${this.element.find('[name="price"]').val()}`.split(',');
        $(document).on('range.onChange', this.updateFilters);
        this.updateFilters();
    }

    toggle(): void {
        this.dropdown.toggleClass('is-open');
    }

    clearAllFilters(event: JQuery.ClickEvent = null): void {
        if (event) {
            event.preventDefault();
        }

        this.onlyFreeToggle.prop('checked', true);
        this.hasBalconyToggle.prop('checked', false);
        this.isCompletedToggle.prop('checked', false);
        this.element.find('[name="rooms"][value=""]').prop('checked', true);
        this.element.find('[name="houseNumber"][value=""]').prop('checked', true);
        this.element.find('[name="apartmentType"][value=""]').prop('checked', true);
        Range.resetAll();

        this.updateFilters();
    }

    updateFilters: (event?: JQuery.TriggeredEvent) => void = (event?: JQuery.TriggeredEvent): void => {
        if (event) {
            const target: JQuery = $(event.currentTarget);

            if (target.attr('name') === 'rooms' && target.is(':checkbox')) {
                const currentValue: string = `${target.val()}`;
                const isChecked: boolean = target.is(':checked');

                if (isChecked && currentValue === '') {
                    this.element.find('[name="rooms"]:checked:not([value=""])').removeAttr('checked');
                } else if (isChecked && currentValue !== null) {
                    this.element.find('[name="rooms"][value=""]:checked').removeAttr('checked');
                } else if (!isChecked && this.element.find('[name="rooms"]:checked').length === 0) {
                    this.element.find('[name="rooms"][value=""]').attr('checked', 'checked').prop('checked', true);
                }
            }
        }

        let roomsRadio: string[] = this.element.find('[name="rooms"]:checked').map((index: number, el: HTMLElement) => `${$(el).val()}`).toArray();
        let houseNumberRadio: string[] = this.element.find('[name="houseNumber"]:checked').map((index: number, el: HTMLElement) => `${$(el).val()}`).toArray();
        let typeRadio: string[] = this.element.find('[name="apartmentType"]:checked').map((index: number, el: HTMLElement) => `${$(el).val()}`).toArray();
        const showOnlyFree: boolean = this.onlyFreeToggle.is(':checked');
        const showOnlyWithBalcony: boolean = this.hasBalconyToggle.is(':checked');
        const showOnlyCompleted: boolean = this.isCompletedToggle.is(':checked');
        const sizeRange: string[] = `${this.element.find('[name="size"]').val()}`.split(',');
        const priceRange: string[] = `${this.element.find('[name="price"]').val()}`.split(',');
        const minSize: number = (sizeRange ? parseInt(sizeRange[0], 10) : 0);
        const maxSize: number = (sizeRange ? parseInt(sizeRange[1], 10) : 999);
        const minPrice: number = (priceRange ? parseInt(priceRange[0], 10) : 0);
        const maxPrice: number = (priceRange ? parseInt(priceRange[1], 10) : 999999);

        const isDefaultPrice: boolean = priceRange.length === 1 || JSON.stringify(this.defaultPriceRange) === JSON.stringify(priceRange);
        const isDefaultSize: boolean = sizeRange.length === 1 || JSON.stringify(this.defaultSizeRange) === JSON.stringify(sizeRange);

        this.tableBody.get(0).scrollTop = 0;

        if (showOnlyFree) {
            $('.sequence, .floorplan-tabs').addClass('is-highlighted');
        } else {
            $('.sequence, .floorplan-tabs').removeClass('is-highlighted');
        }

        if (roomsRadio.indexOf('') !== -1) {
            roomsRadio = [];
        }

        if (houseNumberRadio.indexOf('') !== -1) {
            houseNumberRadio = [];
        }

        if (typeRadio.indexOf('') !== -1) {
            typeRadio = [];
        } else if (typeRadio.indexOf('commercial') !== -1) {
            typeRadio.push('bureau');
            typeRadio.push('hostel');
            typeRadio.push('catering');
        }

        if (
            showOnlyFree ||
            showOnlyWithBalcony ||
            showOnlyCompleted ||
            roomsRadio.length ||
            houseNumberRadio.length ||
            typeRadio.length ||
            !isDefaultPrice ||
            !isDefaultSize
        ) {
            this.clearFilters.css('display', 'inline-flex');
        } else {
            this.clearFilters.hide();
        }

        this.rows.each((index: number, row: HTMLTableRowElement): void => {
            let isVisible: boolean = true;
            const apartment: JQuery = $(row);
            const rooms: string = `${apartment.data('room')}`;
            const houseNumber: string = `${apartment.data('house-number')}`;
            const apartmentType: string = `${apartment.data('apartmenttype')}`;
            const price: number = parseInt(apartment.data('price'), 10);
            const size: number = parseInt(apartment.data('size'), 10);
            const balconySize: number = parseInt(apartment.data('balcony-size'), 10);
            const status: string = `${apartment.data('status')}`;

            if (
                (showOnlyFree && apartment.hasClass('is-disabled')) ||
                (showOnlyWithBalcony && !(balconySize > 0)) ||
                (showOnlyCompleted && !(status === 'ready')) ||
                (roomsRadio.length && roomsRadio.indexOf(rooms) === -1) ||
                (houseNumberRadio.length && houseNumberRadio.indexOf(houseNumber) === -1) ||
                (typeRadio.length && typeRadio.indexOf(apartmentType) === -1) ||
                (size < minSize || size > maxSize) ||
                (price !== 0 && (price < minPrice || price > maxPrice))
            ) {
                isVisible = false;
            }

            if (isVisible) {
                apartment.show();
            } else {
                apartment.hide();
            }
        });
    };

    destroy(): void {
        $(document).off('range.onChange', this.updateFilters);
    }
}
